export default "__VITE_ASSET__DI_Cu1A$__"